import { render, staticRenderFns } from "./baohu.vue?vue&type=template&id=3dd64565&scoped=true&"
import script from "./baohu.vue?vue&type=script&lang=js&"
export * from "./baohu.vue?vue&type=script&lang=js&"
import style0 from "./baohu.vue?vue&type=style&index=0&id=3dd64565&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd64565",
  null
  
)

export default component.exports